import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Translate} from 'react-redux-i18n';

import * as userActions from '../../actions/user';
import * as snackbarsActions from '../../actions/snackbars';
import userService from '../../services/user/UserService';
import {captureError} from '../../utils/log';

import UserSettingsView from './UserSettingsView';

function UserSettingsContainer() {
  const user = useSelector(state => state.user);
  const dispatch = useDispatch();
  const [userDetails, setUserDetails] = React.useState({});
  const [loading, setLoading] = React.useState(true);

  function updateUserDetails() {
    userService.getUserDetailsById(user.id)
      .then(details => {
        setUserDetails(details);
        dispatch(userActions.setUser({
          ...user,
          ...details
        }));
      })
      .catch(error => {
        captureError('Error while updating user details', error);
        dispatch(snackbarsActions.addError(<Translate value="error.generic"/>));
      })
      .finally(() => setLoading(false));
  }

  React.useEffect(updateUserDetails, []);

  return (
    <UserSettingsView
      userDetails={userDetails}
      loading={loading}
      onUpdate={updateUserDetails}
    />
  );
}

export default UserSettingsContainer;
